import { UNKNOWN_TRAFFIC_ID, UNKNOWN_TRAFFIC_SOURCE } from './constants'
import pipelines from './pipelines'

const check = rule => {
  return traffic => {
    return rule(traffic)
  }
}

const checkAllRules = traffic => {
  for (let pipeline of pipelines) {
    const isMatch = check(pipeline.rule)(traffic)
    if (isMatch) {
      return pipeline.extractor(traffic)
    }
  }
  return {
    trafficSource: UNKNOWN_TRAFFIC_SOURCE,
    trafficId: UNKNOWN_TRAFFIC_ID,
  }
}

export default checkAllRules



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/vms/ads/trafficAnalyzer/engine.js